<template>
  <div class="main-page peasants-report">
    <Menus title="农民工讨薪绿色通道">
      <a
        slot="left-link"
        href="javascript:void(0)"
        @click="$router.push('/')"
      >
      </a>
    </Menus>
    <div class="container-flex">
      <div class="steps">
        <div
          id="div_report"
          class="report-container"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
export default {
  components: {
    Menus
  },
  data () {
    return {
      appback: '',
      step: ''
    }
  },
  mounted () {
    if (this.$route.fullPath) {
      var url = 'https://yn.12348.laway.cn/api/get' + this.$route.fullPath.replace('peasantsStrive', 'case')
      $.get(url, results => { // eslint-disable-line
        if (results.status === 1) {
          $('#div_report').html(results.result.content) // eslint-disable-line
          this.report = results.result.content
          this.$nextTick(() => {
            if (window.step) {
              this.step = parseInt(window.step)
            }
            if (document.getElementById('rotue_jump')) {
              document.getElementById('rotue_jump').onclick = e => {
                var href = e.target.dataset.href + '?step=' + this.step
                this.$router.push(href)
              }
            }
            if (window.appback) {
              this.appback = window.appback
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.peasants-report
  #div_report
    width 12rem
    margin 0.7rem auto 0 auto
    border-radius 0.3rem
    padding 0.5rem 0
    background-color rgba(255, 255, 255, 0.2)
    border solid 1px rgba(255, 255, 255, 0.2)
    box-shadow 0 0.1rem 0.25rem rgba(0, 0, 0, 0.05)
    color #fff
    .weui-msg
      text-align center
      padding 50px 0 100px
    i.weui-icon-success.weui-icon_msg
      display block
      background url('https://qiniu.laway.cn/0525b6a877e111e9ab49525400436b39.png') no-repeat
      width 1rem
      height 1rem
      background-size 100%
      margin 0 auto 0.2rem
    h2.weui-msg__title
      font-size 0.26rem
      padding 0.1rem 0
    p
      font-size 0.22rem
</style>
